var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('PageIntro',{attrs:{"heading":'Link Your <span>' +
      _vm.configStrings.clubName +
      ' ' +
      _vm.configStrings.productName +
      '</span>',"body":''}}),(_vm.addressComplete === true)?_c('div',[_c('UserProfileSeatgeekLink',{on:{"link-update":_vm.userProfileSeatgeekLinkResponse}})],1):_vm._e(),(_vm.addressComplete === false)?_c('div',[_c('UserProfileAddress',{on:{"address-update":_vm.userProfileAddressResponse}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }